import React from 'react';
import { Box, InputAdornment, TextField, Typography } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

interface PageHeaderProps {
  search: string;
  onSearchChange: (value: string) => void;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ search, onSearchChange }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        flexWrap: 'wrap',
        mb: 3,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          color: 'var(--color-text-strong)',
          fontSize: { xs: '1.25rem', sm: '1.5rem' },
        }}
      >
        Select a Site Plan to View
      </Typography>
      <TextField
        size="small"
        placeholder="Search site plans..."
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{ minWidth: { xs: '100%', sm: 260 } }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: 'rgba(var(--color-text-rgb), 0.5)' }} />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default PageHeader;
